import React, { Component } from "react"
import ReactCardFlip from 'react-card-flip';
import "./FlipItem.scss"
import BuyButton from "../../Helpers/Buttons/BuyButton";
import { push } from "../../Services/Analytics";

class FlipItem extends Component {
    constructor(props) {
        super();
        this.state = {
            isFlipped: false
        }
        this.handleClick = this.handleClick.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.index != nextProps.flipSide) {
            this.setState({
                isFlipped: false
            })
        }
    }
    handleClick(e, label) {
        e.preventDefault();
        this.props.setflipSide(this.props.index);
        push("Flip_Section", this.props.data.name);
        this.setState({
            isFlipped: !this.state.isFlipped
        });
    }
    render() {
        const _FrontImage = {
            backgroundImage: `url(./static/images/stats/${this.props.ID}/${this.props.index}.jpg)`
        }
        return (
            <div className="flip">
                <ReactCardFlip isFlipped={this.state.isFlipped}>
                    <div key="front" onClick={(event) => { this.handleClick(event) }}>
                        <div className="front" style={_FrontImage}></div>
                        <div className="button">
                            <div className="text">
                                {this.props.data.name}
                            </div>
                        </div>
                    </div>
                    <div key="back" onClick={(event) => { this.handleClick(event) }} className={`${this.props.data.isTrue === true ? "current" : "wrong"}`}>
                        <div className="back">
                            <div className="padding">
                                <div className="icon"></div>
                                <div className="text" dangerouslySetInnerHTML={{ __html: this.props.HTML }}></div>
                                {this.props.link ? <BuyButton sectionName="רכיב ההשוואות" buttonText={`${this.props.purchaseBtn ? this.props.purchaseBtn : "לחצו להזמנה"}`} onClick={() => window.open(this.props.link, "_blank")} /> : ""}
                            </div>
                        </div>
                        <div className={`button`} onClick={() => this.props.handlePaging(this.props.currentFlip + 1)}>
                            <div className="text">
                            {this.props.ID + 1 == this.props.length ? "חזרה להתחלה" : "לשאלה הבאה"}
                            </div>
                        </div>
                    </div>
                </ReactCardFlip>
            </div>
        )
    }
}

export default FlipItem;


// WEBPACK FOOTER //
// ./src/Components/FakeStats/Flip/FlipItem.jsx